export const footer = {
  madeWithBy: "Made with ♥ by",
  and: "and",
  company: "ZIGG SAS doing business as Klap",
  terms: "Terms of services",
  privacy: "Privacy policy",
  tagline: "Turn videos into viral shorts",
  resources: "Resources",
  blog: "Blog",
  tools: "Tools",
  apiDocs: "API Docs",
  discord: "Discord",
  forClippers: "For clippers",
  services: "Services",
  becomeAffiliate: "Become an affiliate",
  api: "API",
  mcp: "MCP server",
  integrations: "Integrations",
  zapier: "Zapier",
  make: "Make",
  n8n: "n8n",
  alternatives: "Alternatives",
  allAlternatives: "All alternatives",
};
